/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import { Wrap, ExpandedItem } from './styles';

const Overlay = ({
    className, closeOverlay, benefitList, activeIndex,
}) => (
    <Wrap className={className}>
        <ExpandedItem
            itemData={benefitList[activeIndex]}
            closeOverlay={closeOverlay}
        />
    </Wrap>
);

Overlay.propTypes = {
    className: PropTypes.string,
    closeOverlay: PropTypes.func,
    benefitList: PropTypes.arrayOf(PropTypes.object),
    activeIndex: PropTypes.number,
};

Overlay.defaultProps = {
    className: '',
    closeOverlay: () => {},
    benefitList: [],
    activeIndex: null,
};

export default Overlay;
